import styled from 'styled-components';
import { ApButtonIcon, colors } from '@alixpartners/ui-components';

export const Wrapper = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
`;

export const BackButtonWrapper = styled.div`
	min-width: 500px;
	display: flex;
	margin-left: -10px;
`;

export const TransactionsTitle = styled.div`
	font-weight: normal;
	font-size: 19px;
	display: flex;
	align-items: center;
`;

export const ButtonIcon = styled(ApButtonIcon)`
	&& {
		margin: 0 8px 0 0;
	}
`;

export const Divider = styled.div`
	width: 1px;
	height: 24px;
	margin: 0 6px;
	background-color: ${colors.grey3};
`;

export const FiltersWrapper = styled.div`
	display: flex;
`;
